import { useMemo } from "react";
import { Link, useRouteContext } from "@tanstack/react-router";
import {
  ColoredCardInfo,
  ColoredCardInfoButton,
  ColoredCardInfoDescription,
  ColoredCardInfoHeader,
  ColoredCardInfoTitle,
} from "@/components/colored-card-info";

export const HomeSectionLivancePayEmptyState = (): JSX.Element => {
  const { flags } = useRouteContext({
    strict: false,
  });

  const variationTestFlagValue = useMemo(
    () => flags["grupo-teste-ab-livance-pay-home"],
    [flags],
  );

  const EmptyStates = {
    A: {
      title: "Centralize sua gestão",
      description:
        "Crie uma conta e centralize todos os seus recebimentos, dentro e fora da Livance.",
      buttonLabel: "Ativar agora :)",
      id: "livance-pay-empty-state--card-a",
    },
    B: {
      title: "Veja quem já pagou.",
      description: "Acompanhe os pagamentos dos seus atendimentos em um só lugar.",
      buttonLabel: "Experimentar agora :)",
      id: "livance-pay-empty-state--card-b",
    },
    C: {
      title: "Chega de cobrar paciente.",
      description: "Envie links a qualquer momento e flexibilize seus recebimentos.",
      buttonLabel: "Experimentar agora :)",
      id: "livance-pay-empty-state--card-c",
    },
  };

  const variant = EmptyStates[variationTestFlagValue as keyof typeof EmptyStates];

  return (
    <Link to="/settings/payments" id={variant.id}>
      <ColoredCardInfo>
        <ColoredCardInfoHeader>
          <ColoredCardInfoTitle>{variant.title}</ColoredCardInfoTitle>
          <ColoredCardInfoDescription>{variant.description}</ColoredCardInfoDescription>
        </ColoredCardInfoHeader>
        <ColoredCardInfoButton>{variant.buttonLabel}</ColoredCardInfoButton>
      </ColoredCardInfo>
    </Link>
  );
};
